import { render, staticRenderFns } from "./TestFormulas.vue?vue&type=template&id=44a27961&"
import script from "./TestFormulas.vue?vue&type=script&lang=js&"
export * from "./TestFormulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports